// 租户后台现货返佣仅使用简体中文。
export default {
  "coin": "现货手续费币种",
  "total": "现货汇总手续费(USDT)",
  "contractRate": "合约返佣比例（%）",
  "spotRate": "现货返佣比例（%）",
  "paid": "现货已发返佣",
  "payable": "现货实际应发返佣",
  "pending": "待结算",
  "multi": "多比例",
  "totalU": "贡献手续费返佣汇总(USDT)",
  "noPayment": "无需发放"
}
